import {useMutation} from '@tanstack/react-query'
import {sendChatFile} from '../services/chat.http'

export const useSendMedia = () =>
    useMutation({
        mutationFn: sendChatFile
    })
